import * as React from "react";

import SvgIcon from "@material-ui/core/SvgIcon";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

export const ShareAltIcon = (props: SvgIconProps) => {
    const {
        viewBox = "0 0 21 25",
        ...rest
    } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest} >
            <path d="M1.92188 10.4001V21.928C1.92188 22.7959 2.74072 23.5 3.75 23.5H17.1562C18.1655 23.5 18.9844 22.7959 18.9844 21.928V10.4001C18.9844 9.53224 18.1655 8.82812 17.1562 8.82812H14.3039V9.87612H17.1562C17.4914 9.87612 17.7656 10.1119 17.7656 10.4001V21.928C17.7656 22.2162 17.4914 22.452 17.1562 22.452H3.75C3.41484 22.452 3.14062 22.2162 3.14062 21.928V10.4001C3.14062 10.1119 3.41484 9.87612 3.75 9.87612H7V8.82812H3.75C2.74072 8.82812 1.92188 9.53224 1.92188 10.4001Z"/>
            <path d="M10.1027 0.165234L5.71211 4.56055C5.4918 4.78086 5.4918 5.13711 5.71211 5.36211L6.03555 5.68555C6.25586 5.90586 6.6168 5.90117 6.83711 5.67617L9.7043 2.66367V14.8652C9.7043 15.1746 9.95742 15.4277 10.2668 15.4277H10.7355C11.0449 15.4277 11.298 15.1746 11.298 14.8652V2.66367L14.1652 5.67148C14.3809 5.90117 14.7465 5.90117 14.9668 5.68086L15.2902 5.35742C15.5105 5.13711 15.5105 4.78086 15.2902 4.56055L10.8996 0.165234C10.6793 -0.0550781 10.323 -0.0550781 10.1027 0.165234Z"/>
        </SvgIcon>
    );
};
